import { FormControl, FormLabel, Input, Link, Sheet, Typography } from "@mui/joy";
import React from "react";
import { Util } from "../Helpers/Util";
import WrappedButton from "../WrappedButton";
import "./Login.css";

interface LoginProps {
	onLogin: Function;
}
export default function Login(props: LoginProps) {
	const [user, setUser] = React.useState("");
	const [pass, setPass] = React.useState("");
	const [error, setError] = React.useState(false);
	const [isTryLogin, setIsTryLogin] = React.useState(false);

	const tryLogin = () => {
		if (Util.isNullOrEmpty(user) || Util.isNullOrEmpty(pass)) {
			alert("Email address and password are required.");
			return;
		}
		setIsTryLogin(true);
		fetch("User/CheckLogin", {
			method: "Post",
			cache: "no-cache",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({
				email: user,
				password: pass,
			}),
		}).then((x) => {
			if (!x.ok || x.status === 204) {
				setError(true);
				setIsTryLogin(false);
				return;
			}

			props.onLogin();

		});
	};

	const forgot = () => {
		fetch("User/SendPasswordReset", {
			method: "Post",
			cache: "no-cache",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify(user),
		}).then((x) => {
			alert("If an account with that email was found, a reset link has been sent to it.");
		});
	}
	return (
		<div className="login-wrapper">
			<Sheet
				sx={{
					mx: "auto",
					width: 300,
					px: 2,
					py: 3,
					gap: 2,
					display: "flex",
					flexDirection: "column",
					borderRadius: 0,
					boxShadow: "md",
				}}
				variant="outlined">
				<div>
					<Typography level="h4" component="h1">
						<b>Welcome!</b>
					</Typography>
					<Typography level="body-sm">Sign in to continue.</Typography>
				</div>
				<FormControl>
					<FormLabel>Email Address</FormLabel>
					<Input name="email" type="email" placeholder="email@address.com" onChange={(event) => setUser(event.target.value)}></Input>
				</FormControl>
				<FormControl>
					<FormLabel>Password</FormLabel>
					<Input name="password" type="password" placeholder="password" onChange={(event) => setPass(event.target.value)} onKeyUp={(event) => event.which === 13 && tryLogin()}></Input>
				</FormControl>
				{error && (
					<Typography sx={{ p: 1, textAlign: "center" }} color="danger" variant="soft" fontSize="sm">
						Invalid email or password.
					</Typography>
				)}
				<WrappedButton busy={isTryLogin} onClick={tryLogin} sx={{ mt: 1 }}>
					Log in
				</WrappedButton>
				<Link onClick={forgot}>
					Forgot Password?
				</Link>
			</Sheet>
		</div>
	);
}
